module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("amBxW"))).then(() => parcelRequire('iDabs'));